export default __webpack_public_path__ + "static/media/nex_logo.8f78872f.svg";